// @flow
import React from 'react';
import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';

import { CapsuleCollapseLists } from 'Components/frameworks/capsule-collapse-lists/CapsuleCollapseLists.jsx';
import { Title } from 'Components/frameworks/title/Title.jsx';
import { type IconName } from 'Components/frameworks/icon/Icon.jsx';

import {
  ProductFeatureDetailService,
  type ProductFeatureDetailServiceProps,
} from './ProductFeatureDetailService.jsx';

type Props = {
  className?: string,
  color?: Colors,
  equipmentsTitle?: string,
  equipments?: ?Array<{
    items: ?Array<{
      iconName?: IconName,
      label: string,
    }>,
    title: string,
  }>,
  items: Array<ProductFeatureDetailServiceProps>,
  title?: string,
  titleIcon?: IconName,
};

export function ProductFeatureDetailServices(props: Props) {
  const {
    className,
    color = COLORS.GRAY_DARKER,
    equipmentsTitle = '',
    equipments = [],
    items = [],
    title = '',
    titleIcon,
  } = props;

  if (!items.length) {
    return null;
  }

  const hasEquipements = !!equipments?.length;

  return (
    <section className={className}>
      <Title
        className="mb-5 sm:mb-4"
        color={color}
        hLevel={3}
        iconName={titleIcon}
        theme="title-brand-5"
      >
        {title}
      </Title>
      <div className={classnames({ 'sm:flex -m-2': hasEquipements })}>
        <div className={hasEquipements ? 'sm:w-1/2' : 'sm:flex flex-wrap -m-2'}>
          {items.map(item => {
            return (
              !!item?.title && (
                <div className={classnames('p-2', { 'sm:w-1/2': !hasEquipements })} key={item.id}>
                  <ProductFeatureDetailService
                    badges={item.badges}
                    color={color}
                    duration={item.duration}
                    id={item.id}
                    items={item.items}
                    level={item.level}
                    note={item.note}
                    targetPrice={item.targetPrice}
                    title={item.title}
                  />
                </div>
              )
            );
          })}
        </div>
        {hasEquipements && (
          <div className="sm:w-1/2 p-2">
            <CapsuleCollapseLists
              header={{
                iconName: ICONS.ALL_INCLUSIVE,
                title: equipmentsTitle,
              }}
              lists={equipments}
              style={{ maxWidth: 380 }}
            />
          </div>
        )}
      </div>
    </section>
  );
}
